<script>
  export default {
  }
</script>
<template>
  <svg width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.3995 0.5H15.8541L10.493 6.62603L16.7998 14.9633H11.8628L7.9932 9.90808L3.57077 14.9633H1.11271L6.84587 8.4096L0.799805 0.5H5.86195L9.35608 5.1206L13.3995 0.5ZM12.5373 13.4961H13.8967L5.1214 1.8907H3.66117L12.5373 13.4961Z" fill="currentColor"/>
  </svg>
</template>
